import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { LocalStoreService } from "../../shared/services/local-store.service";

@Injectable()
export class InvoicesService {
  private baseUrl: string = '';
  private baseUrlEntries: string = '';
  private baseUrlStripe: string = '';

  private collection: string = 'invoices';
  public owner: string;
  public account: string;
  public ownerName: string;
  public profile: string; 
  public organizationId: string;

  items: any[];

  constructor(private http: HttpClient, public local: LocalStoreService) {
    this.baseUrl=this.local.getItem('url.base')+'/'+this.collection; 
    this.owner    = this.local.getItem('user.id');  
    this.account  = this.local.getItem('user.account');  
    this.ownerName   = this.local.getItem('user.fullname');  
    this.profile = this.local.getItem('user.profile'); 
    this.organizationId = this.local.getItem('user.organizationId');
    
    this.baseUrlEntries=this.local.getItem('url.base')+'/entries'; 
    this.baseUrlStripe=this.local.getItem('url.base')+'/stripe'; 

    let itemSub: Subscription;
  }

  // get entries by account
  findEntriesByAccount(): Observable<any> {
    return this.http.get(this.baseUrlEntries+'/account/'+this.account);
  }
  // get entries by company
  findEntriesByCompany(id: string): Observable<any> {
    return this.http.get(this.baseUrlEntries+'/company/'+id);
  }



  // get by id
  findById(id): Observable<any> {
    return this.http.get(this.baseUrl+'/id/'+id);
  }

  // get by order
  findByOrder(id): Observable<any> {
    return this.http.get(this.baseUrl+'/order/'+id);
  }

  // get by quote
  findByQuote(id): Observable<any> {
    return this.http.get(this.baseUrl+'/quote/'+id);
  }



  // get by owner
  findByOwner(): Observable<any> {
    return this.http.get(this.baseUrl+'/owner/'+this.owner);
  }

  // get by account
  findByAccount(): Observable<any> {
    if (this.profile == "CUSTOMER"){
      return this.http.get(this.baseUrl+'/customer/'+this.organizationId);
    }
    else {
      return this.http.get(this.baseUrl+'/account/'+this.account);
    }
  }


  // get by buyer for suppliers invoices
  findByBuyer(): Observable<any> {
    return this.http.get(this.baseUrl+'/buyer/'+this.account);
  }
   



  // get by account and Report
  findByAccountAndIdReport(id): Observable<any> {
    return this.http.get(this.baseUrl+'/account/'+this.account+'/report/'+id);
  }

  // get by account and Report
  findByRecurring(id): Observable<any> {
    return this.http.get(this.baseUrl+'/account/'+this.account+'/recurring/'+id);
  }

  // get by account Status
  findByAccountStatus(status: string): Observable<any> {
    return this.http.get(this.baseUrl+'/account/'+this.account+'/status/'+status);
  }

 
  // get by company
  findByCompany(id): Observable<any> {
    return this.http.get(this.baseUrl+'/company/'+id);
  }

   // get unpaid supplier
  findUnpaidCompany(id): Observable<any> {
    return this.http.get(this.baseUrl+'/buyer/status/due/'+id);
  }


  findByCompanyStatus(id: string, status: string): Observable<any> {
    return this.http.get(this.baseUrl+'/company/'+id+'/status/'+status);
  }

  // get by company
  findByCustomer(id): Observable<any> {
      return this.http.get(this.baseUrl+'/customer/'+id);
  }
  
  // get by Keywords
  findByKeywords(id): Observable<any> {
    return this.http.get(this.baseUrl+'/search/'+this.account+'/'+id);
  }

  sendInvoice(id){
    return this.http.get(this.baseUrl+'/send/'+id);
  }

  // create invoice
  create(item){
    item.recordId = Math.round(Math.random() * 10000000000).toString();
    item.owner = this.owner;
    item.account = this.account;
    item.ownerName = this.ownerName;

    return this.http.post(this.baseUrl, item);
  }

  // create invoice
  createSupplier(item){
    item.recordId = Math.round(Math.random() * 10000000000).toString();
    item.owner = this.owner;
    item.account = this.account;
    item.buyer = this.account;
    item.ownerName = this.ownerName;

    item.organizationId = this.organizationId;

    console.log (item);

    return this.http.post(this.baseUrl+'/supplier', item);
  }

  // get unpaid supplier
  findUnpaidSupplier(id): Observable<any> {
    return this.http.get(this.baseUrl+'/unpaid/buyer/'+this.account+'/company/'+id);
  }

  // get unpaid company
  findUnpaid(id): Observable<any> {
    return this.http.get(this.baseUrl+'/unpaid/company/'+id);
  }


  // create Stripe payment
  createStripePayment(item){
       return this.http.post(this.baseUrlStripe+"/create-charge", item);
  }
  



  update(item){
    return this.http.put(this.baseUrl, item); 
  }

  // ----------------------------------------------------
  // Settings
  // ----------------------------------------------------
  findSettingsByAccount(): Observable<any> {
    var url=this.local.getItem('url.base')+'/settings'; 
    return this.http.get(url+'/account/'+this.account);
  }

  createSettings(item){
    var url=this.local.getItem('url.base')+'/settings'; 
    item.owner = this.owner;
    item.account = this.account;
    item.ownerName = this.ownerName;

    return this.http.post(url, item);
  }

  updateSettings(item){
    var url=this.local.getItem('url.base')+'/settings'; 
    return this.http.put(url, item); 
  }
  
  // ----------------------------------------------------
  // Recurring
  // ----------------------------------------------------

  // get by id
  findRecurringById(id): Observable<any> {
    return this.http.get(this.baseUrl+'/recurring'+'/id/'+id);
  }

  // get by owner
  findRecurringByOwner(): Observable<any> {
    return this.http.get(this.baseUrl+'/recurring'+'/owner/'+this.owner);
  }

  // get by account
  findRecurringByAccount(): Observable<any> {
    if (this.profile == "CUSTOMER"){
      return this.http.get(this.baseUrl+'/recurring'+'/customer/'+this.organizationId);
    }
    else {
      return this.http.get(this.baseUrl+'/recurring'+'/account/'+this.account);
    }
  }

  // get by account and Report
  findRecurringByAccountAndIdReport(id): Observable<any> {
    return this.http.get(this.baseUrl+'/recurring'+'/account/'+this.account+'/report/'+id);
  }

  // get by account Status
  findRecurringByAccountStatus(status: string): Observable<any> {
    return this.http.get(this.baseUrl+'/recurring'+'/account/'+this.account+'/status/'+status);
  }

  
  // get by company
  findRecurringByCompany(id): Observable<any> {
    return this.http.get(this.baseUrl+'/recurring'+'/company/'+id);
  }

  findRecurringByCompanyStatus(id: string, status: string): Observable<any> {
    return this.http.get(this.baseUrl+'/recurring'+'/company/'+id+'/status/'+status);
  }

  // get by company
  findRecurringByCustomer(id): Observable<any> {
      return this.http.get(this.baseUrl+'/recurring'+'/customer/'+id);
  }
  
  // get by Keywords
  findRecurringByKeywords(id): Observable<any> {
    return this.http.get(this.baseUrl+'/recurring'+'/search/'+this.account+'/'+id);
  }

  // create invoice
  createRecurring(item){
    item.recordId = Math.round(Math.random() * 10000000000).toString();
    item.pubDate = new Date();
    item.owner = this.owner;
    item.account = this.account;
    item.ownerName = this.ownerName;

    return this.http.post(this.baseUrl+'/recurring', item);
  }

  updateRecurring(item){
    return this.http.put(this.baseUrl+'/recurring', item); 
  }



   // delete demande
   delete(row, demandes) {
    let id = row.id;
    this.items = demandes;

    let i = this.items.indexOf(row);
    let index = 0;
    for (let item of this.items) {
      if (item.id==id){
        i=index;
      } 
      index++;
    }

    this.baseUrl = this.local.getItem('url.base')+'/pricing/remove'; 
    this.http.delete(this.baseUrl+'/'+id).subscribe(res => console.log(res ));
    this.items.splice(i, 1);
    return of(this.items.slice()).pipe(delay(100));
  } 


}
